import { render, staticRenderFns } from "./ChatMessageBubble.vue?vue&type=template&id=34a9d5c6&scoped=true"
import script from "./ChatMessageBubble.vue?vue&type=script&lang=js"
export * from "./ChatMessageBubble.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageBubble.vue?vue&type=style&index=0&id=34a9d5c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a9d5c6",
  null
  
)

export default component.exports